
























































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DxChart, {
  DxSeries,
  DxLegend,
  DxTooltip,
  DxLabel,
  DxValueAxis,
  DxConstantLine,
  DxConnector,
} from "devextreme-vue/chart";
import productoModule from "@/store/modules/producto-module";
import { producto } from "@/shared/dtos/producto";
import { UtilsString } from "@/utils/utils-string";
import datos_adicionales_productoModule from "@/store/modules/datos_adicionales_producto-module";
import { ProcessoNums } from "../procesos/ProcessoNums";
import PieChart from "@/components/Charts/pie-chart.vue";
import InformeVentas from "@/views/home/InformeVentas.vue";
import pedidoModule from "@/store/modules/pedido-module";
import { pedido } from "@/shared/dtos/pedido";

@Component({
  components: {
    InformeVentas,
    DxChart,
    DxSeries,
    DxLegend,
    DxTooltip,
    DxLabel,
    DxValueAxis,
    DxConstantLine,
    DxConnector,
    PieChart,
  },
})
export default class DashGeneral extends Vue {
  totalVentas: number = 0;
  totalIngresos: number = 0;
  margenPromedio: number = 0;
  tasaRentabilidad: number = 0;
  ticketMedio: number = 0;

  productosEnStock: number = 0;
  devoluciones: number = 0;
  precioStock: number = 0;
  gananciaEstimada: number = 0;
  totalRetail: number = 0;
  totalRetailActualizado: number = 0;
  pendientePago: number = 0;
  reservasProductos: number = 0;
  productosMermaRoto: number = 0;
  productosEnReparacion: number = 0;
  productosEnEnvio: number = 0;
  precioVentaEnvio: number = 0;
  costeMermaRoto: number = 0;
  precioMedioStock: number = 0;

  ventasPorFecha: any[] = [];
  ventasPorCategoria: any[] = [];
  inventarioActual: any[] = [];
  productosMasVendidos: any[] = [];
  analisisRentabilidad: any[] = [];
  recuentoPorCondicion: any[] = [];
  rentabilidadPorPkgId: any[] = [];

  coste_pedidos: number = 0;
  porcentaje_pagado: number = 0;

  /*********************FILTROS DE DATOS*********************/
  selectedPedidos: number[] = [];
  pedidos: pedido[] = [];
  fechaDesde: string | null = null;
  fechaHasta: string | null = null;
  menu1: boolean = false;
  menu2: boolean = false;

  get revalorizacion() {
    return (
      ((this.totalRetailActualizado - this.totalRetail) / this.totalRetail) *
      100
    ).toFixed(2);
  }
  mounted() {
    this.fetchDashboardData();
  }

  @Watch("selectedPedidos")
  onSelectedPedidoChange() {
    this.fetchDashboardData();
  }
  @Watch("fechaDesde")
  onFechaDesdeChange() {
    this.fetchDashboardData();
  }

  @Watch("fechaHasta")
  onFechaHastaChange() {
    this.fetchDashboardData();
  }

  async fetchDashboardData() {
    const data = await this.getMockData();
    let productos: producto[] = data.productos;

    // Generar filtros
    this.pedidos = data.pedidos;
    if (this.selectedPedidos.length === 0) {
      this.selectedPedidos = this.pedidos.map((p) => p.id);
    }

    // Filtrar productos por pedidos seleccionados
    productos = productos.filter((p) =>
      this.selectedPedidos.includes(p.id_pedido)
    );
    // Filtrar productos por fecha
    if (this.fechaDesde) {
      productos = productos.filter(
        (p) => new Date(p.fecha_venta) >= new Date(this.fechaDesde!)
      );
    }
    // Filtrar productos por fecha
    if (this.fechaHasta) {
      productos = productos.filter(
        (p) => new Date(p.fecha_venta) <= new Date(this.fechaHasta!)
      );
    }
    //Coste pedidos
    var pedidos = data.pedidos.filter((p) =>
      this.selectedPedidos.includes(p.id)
    );
    this.coste_pedidos = pedidos.reduce((sum, p) => sum + p.precio_con_iva, 0);
    this.coste_pedidos = Math.round(this.coste_pedidos * 100) / 100;

    // Resumen de ventas
    this.totalVentas = productos
      .filter((p) => p.vendido)
      .reduce((sum, p) => sum + p.qty, 0);
    this.totalIngresos = productos
      .filter((p) => p.vendido)
      .reduce((sum, p) => sum + p.precio_vendido, 0);
    this.margenPromedio =
      productos
        .filter((p) => p.vendido)
        .reduce((sum, p) => sum + (p.precio_vendido - p.coste_compra), 0) /
      productos.filter((p) => p.vendido).length;
    this.tasaRentabilidad =
      ((this.totalIngresos -
        productos
          .filter((p) => p.vendido)
          .reduce((sum, p) => sum + p.coste_compra, 0)) /
        productos
          .filter((p) => p.vendido)
          .reduce((sum, p) => sum + p.coste_compra, 0)) *
      100;
    this.ticketMedio = this.totalIngresos / this.totalVentas;
    this.ticketMedio = Number.parseFloat(this.ticketMedio.toFixed(2));

    this.tasaRentabilidad = Number.parseFloat(this.tasaRentabilidad.toFixed(2));
    this.totalIngresos = Number.parseFloat(this.totalIngresos.toFixed(2));
    this.margenPromedio = Number.parseFloat(this.margenPromedio.toFixed(2));

    // Nuevas métricas
    this.productosEnStock = productos.filter(
      (p) => p.estado === 0 && !p.vendido
    ).length;
    this.devoluciones = this.getDevoluciones().length; // Dato inventado
    this.precioStock = productos
      .filter((p) => p.estado === 0 && !p.vendido)
      .reduce((sum, p) => sum + p.coste_compra, 0);
    this.gananciaEstimada = this.precioStock * (this.tasaRentabilidad / 100);

    this.totalRetail = productos.reduce((sum, p) => sum + p.total_retail, 0);
    this.totalRetailActualizado = productos.reduce(
      (sum, p) => sum + p.ultimo_precio_amazon,
      0
    );

    this.reservasProductos = productos.filter(
      (p) => p.estado === ProcessoNums.Reservado
    ).length;
    this.productosMermaRoto = productos.filter(
      (p) => p.estado === ProcessoNums.MermaRoto
    ).length;

    this.productosEnReparacion = productos.filter(
      (p) => p.estado === ProcessoNums.Reparacion
    ).length;

    this.productosEnEnvio = productos.filter(
      (p) => p.estado === ProcessoNums.Envio
    ).length;

    this.precioVentaEnvio = productos
      .filter((p) => p.estado === ProcessoNums.Envio)
      .reduce((sum, p) => sum + p.precio_vendido, 0);
    this.costeMermaRoto = productos
      .filter((p) => p.estado === ProcessoNums.MermaRoto)
      .reduce((sum, p) => sum + p.coste_compra, 0);
    this.pendientePago = productos
      .filter((p) => p.estado === ProcessoNums.PendientePago)
      .reduce((sum, p) => sum + p.precio_vendido, 0);
    this.precioVentaEnvio = Math.round(this.precioVentaEnvio * 100) / 100;
    this.costeMermaRoto = Math.round(this.costeMermaRoto * 100) / 100;
    this.pendientePago = Math.round(this.pendientePago * 100) / 100;

    this.precioMedioStock = this.precioStock / this.productosEnStock;

    this.costeMermaRoto = Number.parseFloat(this.costeMermaRoto.toFixed(2));

    this.precioMedioStock = Number.parseFloat(this.precioMedioStock.toFixed(2));

    this.totalRetail = Number.parseFloat(this.totalRetail.toFixed(2));
    this.totalRetailActualizado = Number.parseFloat(
      this.totalRetailActualizado.toFixed(2)
    );
    this.precioStock = Number.parseFloat(this.precioStock.toFixed(2));
    this.gananciaEstimada = Number.parseFloat(this.gananciaEstimada.toFixed(2));

    // Tendencias temporales
    const ventasPorFechaMap = productos
      .filter((p) => p.vendido)
      .reduce((acc: any, p) => {
        const date = this.formatDate(p.fecha_venta);
        if (!acc[date]) {
          acc[date] = 0;
        }
        acc[date] += 1;
        return acc;
      }, {});

    this.ventasPorFecha = Object.keys(ventasPorFechaMap)
      .map((date) => ({
        date,
        ventas: ventasPorFechaMap[date],
      }))
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    const sortByDateAscending = (arr: { date: string; ventas: number }[]) => {
      return arr.sort((a, b) => {
        const dateA = new Date(a.date.split("/").reverse().join("-")); // Convertir DD/MM/YYYY a YYYY-MM-DD
        const dateB = new Date(b.date.split("/").reverse().join("-"));
        return dateA.getTime() - dateB.getTime(); // Ordenar por fecha ascendente
      });
    };

    this.ventasPorFecha = sortByDateAscending(this.ventasPorFecha);

    // Recuento de productos por condición
    const condicionMap = productos.reduce((acc: any, p) => {
      if (!acc[p.condicion]) {
        acc[p.condicion] = 0;
      }
      acc[p.condicion] += 1;
      return acc;
    }, {});

    this.recuentoPorCondicion = Object.keys(condicionMap).map((condicion) => ({
      condicion,
      cantidad: condicionMap[condicion],
    }));

    // Rentabilidad de productos vendidos por PKG ID
    const rentabilidadMap = productos
      .filter((p) => p.vendido)
      .reduce((acc: any, p) => {
        if (!acc[p.pkg_id]) {
          acc[p.pkg_id] = 0;
        }
        acc[p.pkg_id] += p.precio_vendido - p.coste_compra;
        return acc;
      }, {});

    this.rentabilidadPorPkgId = Object.keys(rentabilidadMap).map((pkg_id) => ({
      pkg_id,
      rentabilidad: Number.parseFloat(rentabilidadMap[pkg_id].toFixed(2)),
    }));

    // Análisis por categorías
    const categorias = productos
      .filter((p) => p.vendido)
      .reduce((acc: any, p: any) => {
        const categoria = acc.find((c: any) => c.categoria === p.category);
        if (categoria) {
          categoria.ventas += 1;
        } else {
          if (UtilsString.IsNullOrWhiteSpace(p.category)) {
            p.category = "Sin Categoria";
          }
          acc.push({ categoria: p.category, ventas: 1 });
        }
        return acc;
      }, []);
    this.ventasPorCategoria = categorias
      .sort((a: any, b: any) => b.ventas - a.ventas)
      .slice(0, 10);

    // Análisis de inventario
    this.inventarioActual = productos
      .filter((p) => !p.vendido)
      .map((p) => ({ estado: p.estado, cantidad: p.qty }));

    // Productos más vendidos
    const productosVendidos = productos
      .filter((p) => p.vendido)
      .reduce((acc: any, p) => {
        const producto = acc.find((pr: any) => pr.producto === p.asin);
        if (producto) {
          producto.ventas += p.qty;
        } else {
          acc.push({ producto: p.asin, ventas: p.qty, item: p });
        }
        return acc;
      }, []);

    this.productosMasVendidos = productosVendidos
      .sort((a: any, b: any) => b.ventas - a.ventas)
      .slice(0, 10);

    // Análisis de rentabilidad
    this.analisisRentabilidad = productos
      .filter((p) => p.vendido)
      .map((p) => ({
        costo: p.coste_compra,
        precio: p.precio_vendido,
        rentabilidad:
          ((p.precio_vendido - p.coste_compra) / p.coste_compra) * 100,
      }));

    //Calculo porcentaje pagado

    if (this.totalRetailActualizado !== 0) {
      // Evitar división por cero
      this.porcentaje_pagado =
        (this.coste_pedidos / this.totalRetailActualizado) * 100;
      //Redondeamos a dos decimales
      this.porcentaje_pagado = Number.parseFloat(
        this.porcentaje_pagado.toFixed(2)
      );
    }
  }
  formatDate(date: Date): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }
  async getMockData() {
    //Recogida de datos
    await datos_adicionales_productoModule.getdatos_adicionales_productos();
    await productoModule.getproductos();
    await pedidoModule.getpedidos();
    return {
      productos: productoModule.productos,
      pedidos: pedidoModule.pedidos,
      datos_adicionales_productos:
        datos_adicionales_productoModule.datos_adicionales_productos,
    };
  }

  getDevoluciones() {
    return datos_adicionales_productoModule.datos_adicionales_productos.filter(
      (x) => x.tipo_registro === ProcessoNums.Devolucion
    );
  }
  customizeTooltip(arg: any) {
    return {
      text: `Producto: ${arg.point.data.producto}`,
    };
  }
}
